// extracted by mini-css-extract-plugin
export default {"container":"show-settings_container__XFOxf","settings-text":"show-settings_settings-text__t-64I"};